module.exports = __webpack_public_path__ + "static/media/icon_internet.8ab31d3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/resources/os/icon_internet.svg
// module id = 1331
// module chunks = 0